export default __webpack_public_path__ + "static/media/new-pitch-mob.c1b9cd21.png";